module.exports = __webpack_public_path__ + "img/tn.35fc2baa.svg";